/**
 * For a given object, determine whether a valid email address has been provided in the object.
 * Return an error if there's a valid email address was not provided.
 * For the purposes of this function, "valid" means it has the following structure: <text>@<text>.<text>
 * @param {object} data The data to validate.
 */
export default function validateEmail(data) {
  if (!/\S+@\S+\.\S+/.test(data.email)) {
    return new Error("Please provide a valid email address.");
  }
}
